import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { theme } from "../../../styles/theme";
import { Div, Text, Col } from "../../../styles/Common";
import useGetListSurveys from "../hooks/useGetListSurveys";
import toast from "react-hot-toast";
import { calculateAge, dateFormat, getIdSurveyExternal, getIdSurveyInternal, getIdSurveyStatusOpen, getUserInfo, saveTabChange, timeSkeleton } from "../../../utilities/helpers";
import useLazyGetUserProfile from "../../ProfileInfo/hooks/useLazyGetUserProfile";
import useSaveSurveyAnswer from "../hooks/useSaveSurveyAnswer";
import useGetSurveyStatus from "../../../core/hooks/useGetSurveyStatus";
import { SurveyCard, SurveysSkeleton } from "./CardSurveyHomePriv";
import { AiOutlineShopping, AiOutlineSound } from "react-icons/ai";
import useGetSurveyType from "../../../core/hooks/useGetSurveyType";
import { BannerCard, BannerCardsSkeletonList } from "./BannerCard";

import styled from "styled-components";
import useGetBanners from "../../../core/hooks/useGetBanners";
import { useSearchParams } from "react-router-dom";

const MasonryContainer = styled.div`
  column-count: 4;
  column-gap: 24px;
  width: 100%;
  margin-top: 20px;

  @media (max-width: 1440px) {
    column-count: 3;
  }

  @media (max-width: 1024px) {
    column-count: 2;
  }

  @media (max-width: 600px) {
    column-count: 1;
  }
`;




export const HomePriv = ({ name, isMobile, handleViewSurvey, setActiveKey, setEditMyAccount }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingBanners, setIsLoadingBanners] = useState(true);
  const [dataSurveys, setDataSurveys] = useState([]);
  const {nameid} = getUserInfo();
  const getSurveys = useGetListSurveys(Number(nameid));
  const getSurveyStatus = useGetSurveyStatus();
  const getSurveyType = useGetSurveyType();
  const [principalNew, setPrincipalNew] = useState([]);

  useEffect(() => {
    saveTabChange("1");
  }, [])
  
  const { data: dataSurveyStatus, isSuccess: isSuccessSurveyStatus } =
    getSurveyStatus;
  const [optionsSurveyStatus, setOptionsSurveyStatus] = useState([]);
  useEffect(() => {
    if (isSuccessSurveyStatus) {
      setOptionsSurveyStatus(
        dataSurveyStatus?.data?.result.map((item) => ({
          label: item.name,
          value: item.id,
          code: item.code
        }))
      );
    }
  }, [dataSurveyStatus, isSuccessSurveyStatus]);

  const { data: dataSurveyType, isSuccess: isSuccessSurveyType } =
    getSurveyType;
  const [optionsSurveyType, setOptionsSurveyType] = useState([]);
  useEffect(() => {
    if (isSuccessSurveyType) {
      setOptionsSurveyType(
        dataSurveyType?.data?.result.map((item) => ({
          label: item.name,
          value: item.id,
          code: item.code
        }))
      );
    }
  }, [dataSurveyType, isSuccessSurveyType]);

  const getBanners = useGetBanners(null, nameid);
  const { data: dataBanners, isSuccess: isSuccessBanners } =
    getBanners;
  const [bannersOptions, setBannersOptions] = useState([]);
  useEffect(() => {
    if(isSuccessBanners) {
      let bannersList = dataBanners?.data?.result?.map((item) => {
        let icon
        if(item.bannersTypes == "news") icon = <AiOutlineSound size={28} style={{ marginRight: '6px' }} color={theme.colors.green300} />;
        if(item.bannersTypes == "promotions") icon = <AiOutlineShopping size={28} style={{marginRight: '6px'}} color={theme.colors.green300} />;
        return {
          ...item,
          icon: icon
        };
      })
      setPrincipalNew(bannersList?.filter((v, i) => v.default) || null);
      
      setTimeout(() => {
        setIsLoadingBanners(false);
      }, timeSkeleton);
      setBannersOptions(bannersList?.length > 0 ? bannersList: []);
    }
  }, [dataBanners, isSuccessBanners])

  const {
    refetch: refetchUserProfile, 
  } = useLazyGetUserProfile(nameid);
  const { data: dataListSurveys } = getSurveys;

  const filteredSurveys = useMemo(() => {
    if (!dataSurveys.length || !optionsSurveyType.length) return [];
    
    const externalId = getIdSurveyExternal(optionsSurveyType);
    const internalId = getIdSurveyInternal(optionsSurveyType);
    setTimeout(() => {
      setIsLoading(false);
    }, timeSkeleton)
    return dataSurveys.filter(survey => 
      survey.statusId === 1 && 
      (
        survey.typeSurveyId === externalId || 
        (survey.typeSurveyId === internalId && !survey.default)
      ) && 
      !survey.deleted
    );
  }, [dataSurveys, optionsSurveyType]); 

  const saveSurveyAnswer = useSaveSurveyAnswer(Number(nameid), null, null, getIdSurveyExternal(optionsSurveyType));

  const [searchParams, setSearchParams] = useSearchParams();
  
  useEffect(() => {
    const surveyId = searchParams.get("SurveyId");
    if (surveyId && filteredSurveys?.length > 0) {
      const getSurvey = filteredSurveys.find((value) => value.surveyId == surveyId);
      if (getSurvey) {
        onClickSurvey(getSurvey);
        verifyStatusSurvey(getSurvey.progress);

        const newParams = new URLSearchParams(searchParams);
        newParams.delete("SurveyId");
        setSearchParams(newParams, { replace: true });
      }
    }
  }, [searchParams, filteredSurveys]);

  useEffect(() => {
    if(dataListSurveys?.data?.result?.length > 0) {
      const listSurvey = dataListSurveys.data.result;
      setDataSurveys(listSurvey);
      setTimeout(() => {
        setIsLoading(false);
    }, timeSkeleton)
    }
  }, [dataListSurveys]);

  const onClickSurvey = async(data) => {
    if (data?.typeSurveyId === getIdSurveyExternal(optionsSurveyType)) {
      const { data: userProfileData, isSuccess: isSuccessUserProfile, } = await refetchUserProfile();
      if(isSuccessUserProfile && userProfileData?.data?.result[0]) {
        let dataUser = userProfileData?.data?.result[0] || {};
        const petsString = Array.isArray(dataUser?.pets) ? dataUser.pets.join(", ") : "";
        const hobbiesString = Array.isArray(dataUser?.hobbies) ? dataUser.hobbies.join(", ") : "";
        let objDataUser = {
          i: dataUser?.userId,
          nm: dataUser?.name,
          lm: dataUser?.lastName,
          em: dataUser?.email,
          pn: dataUser?.phoneNumber,
          ing: dataUser?.instagram,
          ag: dataUser?.birthDate? calculateAge(dateFormat(dataUser?.birthDate)).toString(): "",
          bd: dateFormat(dataUser?.birthDate),
          ads: dataUser?.address,
          intc: dataUser?.instruction,
          zn: dataUser?.zone? dataUser?.zone.toString(): "",

          ind: dataUser?.phoneNumberCode,
          dpt: dataUser?.department,
          mnt: dataUser?.city,
          mp: dataUser?.exactAddress,
          
          ms: dataUser?.maritalStatus,
          gn: dataUser?.gender,
          
          rl: dataUser?.roleHouseId,
          ir: dataUser?.incomeRange,
          nc: dataUser?.numberChildren,
          pa: dataUser?.frequencyActivitiesPhysical,
          pf: dataUser?.professions,
          
          ip: dataUser?.isPregnant? "Si": "No",
          itt: dataUser?.isInterestedTechnology? "Si": "No",
          hhr: dataUser?.isBuyManagerHome? "Si": "No",
          iac: dataUser?.isAlcoholConsume? "Si": "No",
          itc: dataUser?.isTobaccoConsume? "Si": "No",

          pts: petsString, 
          hbs: hobbiesString, 
        }

        saveSurveyAnswer.reset();
        saveSurveyAnswer.mutate(
            {
              surveyId: data.surveyId,
              status: getIdSurveyStatusOpen(optionsSurveyStatus),
              typeSurvey: getIdSurveyExternal(optionsSurveyType),
              formData: {}
            },
            {
                onSuccess: (res) => {
                  if(res?.data?.result) {
                    const queryParams = new URLSearchParams(objDataUser).toString();
                    const surveyUrl = `${data.surveyUrl}?${queryParams}`;
                    
                    const link = document.createElement('a');
                    link.href = surveyUrl;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    setTimeout(() => {
                      const newWindow = window.open('about:blank', '_blank');
                      if (newWindow) {
                        newWindow.location.href = surveyUrl;
                      }
                    }, 100);
                  } else {
                    toast.error("No se puede abrir esta encuesta. Por favor, inténtalo más tarde.");
                  }
                },
                onError: (err) => {
                  if (err?.response?.data?.errors) {
                    const errorMessages = Object.values(err.response.data.errors)
                      .flat()
                      .join(", ");
                    toast.error(errorMessages);
                  } else {
                    toast.error("No se puede abrir esta encuesta. Por favor, inténtalo más tarde.");
                  }
                }
            }
        );
      }
    } else {
      handleViewSurvey(data, "1");
    }
  };

  const onClickNewsAndPromotions = async(data) => {
    const findSurvey = dataSurveys?.find(item => item?.surveyId == data.code);
    if(findSurvey) {
      handleViewSurvey(findSurvey, "1");
    } else {
      console.log(findSurvey, data, dataSurveys, "Ocurrio un error al intentar abrir el enlace")
      toast.error("Ocurrio un error al intentar abrir el enlace");
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const verifyStatusSurvey = (status) => {
    let getStatus = optionsSurveyStatus.find((survey) => survey.value == status.toString());
    return getStatus;
  }

  return (
    <Div m="0px 0px 100px 0px" p={!isMobile ? "31px 97px 57.23px 98px" : "31px 25px 48px 25px"}>
      <Col>
        <Col>
          <Text
            size={theme.fonts.size.h4}
            weight={theme.fonts.weight.semibold}
            color={theme.colors.white}
            mb="10px"
          >
            Hola,{" "}
            <span style={{ color: theme.colors.red }}>
              {name.split(" ")[0].substring(0, 15)}
            </span>{" "}
          </Text>
          <Text
            size={theme.fonts.size.h3}
            weight={theme.fonts.weight.semibold}
            color={theme.colors.white}
            mb="32px"
          >
            Te damos la bienvenida a la comunidad Pulpey.
          </Text>
          <Text
            size={theme.fonts.size.h6}
            weight={theme.fonts.weight.semibold}
            color={theme.colors.white}
            mb="32px"
          >
            Para poder ser parte de las actividades que las marcas
            tiene para ti, por favor recuerda llenar las encuestas, 
            con esta información podremos enviarte la PulpeyBox más 
            adecuada a tus gustos y preferencias.  Llena las encuestas 
            con confianza y sinceridad. Gracias.
          </Text>
        </Col>
        
        {(bannersOptions.length > 0) && (
          <>
            <Col>
              <Text
                size={theme.fonts.size.h4}
                weight={theme.fonts.weight.semibold}
                color={theme.colors.white}
                /* mb="32px" */
                mb="10px"
              >
                Noticias y Promociones
              </Text>
            </Col>
            <div style={{marginBottom: "-1.2%", marginTop: "0.5%"}}>
              {principalNew?.length > 0 && isLoadingBanners? 
                <BannerCardsSkeletonList count={1} isMobile={isMobile} />:
                (principalNew.map((value, index) => (
                  <BannerCard 
                    key={`banner-default`}
                    item={value}
                    isMobile={isMobile}
                    setActiveKey={setActiveKey}
                    setEditMyAccount={setEditMyAccount}
                    onCardClick={onClickNewsAndPromotions}
                  />
                )))
              }
            </div>
            <MasonryContainer>
              {isLoadingBanners?
                <BannerCardsSkeletonList count={3} isMobile={isMobile} /> :
                bannersOptions.map((item, index) => (!item.default &&
                  <BannerCard 
                    key={`banner-${index}`}
                    item={{ 
                      ...item, 
                      image: item.image || null
                    }}
                    isMobile={isMobile}
                    setActiveKey={setActiveKey}
                    setEditMyAccount={setEditMyAccount}
                    onCardClick={onClickNewsAndPromotions}
                  />
                ))
              }
            </MasonryContainer>
          </>
        )}
        {(filteredSurveys?.length > 0) && (
          <>
            <Col>
              <Text
                size={theme.fonts.size.h4}
                weight={theme.fonts.weight.semibold}
                color={theme.colors.white}
                align="center"
                mb="32px"
                mt="45px"
              >
                Encuestas creadas para ti
              </Text>
            </Col>
            <Div
              direction={!isMobile ? "row" : "column"}
              gap="17px"
              align={isMobile && "center"}
              style={{
                display: "flex",
                flexWrap: "wrap", 
                justifyContent: "flex-start", 
              }}
            >
              {isLoading ?
                <SurveysSkeleton count={3} isMobile={isMobile} />:
                filteredSurveys.map((survey) => (
                  <SurveyCard
                    key={survey.surveyId}
                    survey={survey}
                    isMobile={isMobile}
                    status={verifyStatusSurvey(survey.progress)}
                    onCardClick={() => onClickSurvey(survey)}
                    optionsSurveyStatus={optionsSurveyStatus}
                  />
              ))}
            </Div>
          </>
        )}
      </Col>
    </Div>
  );
};

HomePriv.propTypes = {
  name: PropTypes.string,
  isMobile: PropTypes.bool,
  handleViewSurvey: PropTypes.func,
  setActiveKey: PropTypes.func,
  setEditMyAccount: PropTypes.func,
};
